var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        [
          _c(
            "b-card",
            {
              staticClass: "w-100 card-container",
              attrs: { "bg-variant": "statusWarning" }
            },
            [
              _c("strong", [_vm._v(_vm._s(_vm.$t("xMobileLinkOutage")))]),
              _c("div", { staticClass: "mt-2" }, [
                _vm._v(_vm._s(_vm.$t("xBillingMaintenanceMessage")))
              ])
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }